// Helpers shared by the Comments thread in the Rush editor.

const MENTION_REGEX = /@([A-Z][\w’'\-]+(?: [A-Z][\w’'\-]+)?)/g;

export function relTime(input) {
    if (!input) return '';
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return '';
    const diff = Math.max(0, Date.now() - d.getTime());
    const s = Math.floor(diff / 1000);
    if (s < 60) return 'just now';
    const m = Math.floor(s / 60);
    if (m < 60) return `${m}m`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h`;
    const day = Math.floor(h / 24);
    if (day < 7) return `${day}d`;
    return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function fullTimestamp(input) {
    if (!input) return '';
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleString();
}

export function initialsOf(name) {
    return (name || '?').split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
}

// Deterministic 1..6 avatar bucket from a string id.
export function avatarColor(id) {
    const s = String(id || '');
    let h = 0;
    for (let i = 0; i < s.length; i += 1) {
        h = (h * 31 + s.charCodeAt(i)) >>> 0;
    }
    return (h % 6) + 1;
}

/**
 * Render the comment body with @Mentions highlighted. Returns an array of React
 * children (strings and elements) suitable for inlining inside a span/div.
 */
export function renderBody(body, React) {
    if (!body) return null;
    const parts = [];
    let lastIndex = 0;
    let m;
    const re = new RegExp(MENTION_REGEX.source, 'g');
    let i = 0;
    // eslint-disable-next-line no-cond-assign
    while ((m = re.exec(body)) !== null) {
        if (m.index > lastIndex) parts.push(body.slice(lastIndex, m.index));
        parts.push(
            React.createElement(
                'span',
                { key: `mn-${i}-${m.index}`, className: 'cm-mention' },
                `@${m[1]}`,
            ),
        );
        lastIndex = m.index + m[0].length;
        i += 1;
    }
    if (lastIndex < body.length) parts.push(body.slice(lastIndex));
    return parts;
}

/**
 * Client-side mention parser (server re-parses authoritatively).
 * Returns matched collaborator IDs in order of first occurrence.
 */
export function parseMentions(body, collaborators) {
    if (!body || !Array.isArray(collaborators) || collaborators.length === 0) return [];
    const pool = collaborators.map((c) => ({
        id: c._id || c.id,
        name: (c.name || '').toLowerCase(),
        first: (c.name || '').split(' ')[0].toLowerCase(),
    }));
    const ids = new Set();
    const re = new RegExp(MENTION_REGEX.source, 'g');
    let m;
    // eslint-disable-next-line no-cond-assign
    while ((m = re.exec(body)) !== null) {
        const raw = (m[1] || '').toLowerCase().trim();
        if (!raw) continue;
        const match = pool.find((p) => p.name === raw) || pool.find((p) => p.first === raw);
        if (match) ids.add(match.id);
    }
    return Array.from(ids);
}
